<div class="modal-background" *ngIf="showModal">
    <div class="modal-content justify-content-between ">
        <div [innerHTML]="html" class="d-none" ></div>
        <div class="w-100" *ngIf="showPublicacaoImagem">
          <img [src]="imagem" />
        </div>

        <div class="modal-buttons">
            <!-- <button (click)="submitForm(false)" mat-button>Fechar</button> -->
            <button (click)="submitForm(true)" mat-flat-button>OK</button>
        </div>
    </div>
</div>
